import Base from 'core/pages/Encoding/EncodingVerify'
import { IdentifierType } from 'stylewhere/api'
import { RfidReader, Router } from 'stylewhere/shared'
import { T, __ } from 'stylewhere/shared/i18n'
import {
  getAutomaticRestartAntenna,
  isValidOperationEncodingTagType,
  showToastError
} from 'stylewhere/shared/utils'
import { OperationEncodingTagType } from 'stylewhere/types'

export default class EncodingVerify extends Base {
  startReader = async () => {
    try {
      await RfidReader.initialize(this.getAntennaCustomCommands())
      RfidReader.setOnTagReadCallback(this.onTagRead)
      RfidReader.setAutomaticStop(this.operation.autostopAntennaTimeout > 0)
      RfidReader.setAutomaticStopTime(this.operation.autostopAntennaTimeout)
      RfidReader.onStartCallback = this.onStartCallback
      RfidReader.onStopCallback = this.onStopCallback
      await RfidReader.start({
        onStop: () => {},
        restart: getAutomaticRestartAntenna(this.operation),
        customCommandsOperationType: this.getAntennaCustomCommands()
      })
    } catch (error) {
      showToastError((error as any).message ?? __(T.error.rfid_reader_initialization), __(T.error.error), this.isModal)
    }
  }

  clearReads = async () => {
    this.stopTimer()
    RfidReader.clear()
    if (!RfidReader.isReading()) {
      await RfidReader.start({
        onStop: () => {},
        restart: getAutomaticRestartAntenna(this.operation),
        customCommandsOperationType: this.getAntennaCustomCommands()
      })
    }
    this.setState({
      encodingValidation: { operationId: this.operation.id, identifiers: [] },
      encodingValidationResponse: undefined
    })
  }

  startAntenna = async (tagTypeInput?: OperationEncodingTagType) => {
    const { currentTagType } = this.state
    let tagType: OperationEncodingTagType = currentTagType
    if (isValidOperationEncodingTagType(tagTypeInput)) {
      tagType = tagTypeInput
    }

    if (!RfidReader.isReading()) {
      this.setState({ starting: true })
      await RfidReader.start({
        onStop: () => {},
        restart: getAutomaticRestartAntenna(this.operation),
        tagTypeToCheck: tagType,
        customCommandsOperationType: this.getAntennaCustomCommands()
      })
    }
  }

  _changeTab = async () => {
    let originalTemplatePath = ''
    const { originTemplatePath } = this.state
    if (!originTemplatePath) {
      originalTemplatePath = localStorage.getItem('originTemplatePath') || ''
    } else {
      originalTemplatePath = originTemplatePath
    }
    RfidReader.clear()
    await this.stopAntenna()
    this.timer = setTimeout(() => {
      Router.navigate(`/encoding/${originalTemplatePath ? `${originalTemplatePath}/` : ''}:opCode` as any, {
        opCode: this.operation.code
      })
      localStorage.removeItem('originTemplatePath')
    }, this.operation.options.antennaTurnWaitingInterval ?? 1000)
  }

  getHideIdentifierCodeByType = (): IdentifierType[] | undefined => {
    return ['NFC_TAG']
  }
}
